import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'
const {
  endpoints: {
    company: { commissions: url },
  },
} = config

const getUrl = (commission) => url.replace(':idCompany', commission.company || commission.idCompany)

/**
 * Returns the skeleton of the business management tree.
 * If called with a specific provider, returns saved business model of that provider.
 *
 * @param {String} params.provider Provider key
 */
const getBusinessModel = (params, commission) => axios.get(getUrl(commission), { headers: getHeaders(true), params })

/**
 * Updates a provider business model.
 *
 * @param {Object} data Business model object for a specific provider
 */
const updateBusinessModel = (commission) => axios.post(getUrl(commission), { commission }, { headers: getHeaders(true) })

export default { getBusinessModel, updateBusinessModel }
